/* eslint-disable */
import React, { useState, useEffect } from 'react';
import jwt_decode from "jwt-decode";
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import Modal from '../../ReusableTable/DssModel/DssModel';
import ColumnSelector from '../../ReusableTable/DssColumnSelectionModal/ColumnSelectionModal';
import './DynamicPaginatedTable.css';
import config from '../../../config/config';
import { usePopupManager } from '../../../providers/PopupManager/PopupManager';

const { API_BASE_URL } = config;

const DynamicPaginatedTable = ({ data, columns, itemsPerPage, onPageChange, isCustomOpen, totalRecords, handleCSVDownload, dataLoading }) => {
  const { showPopup } = usePopupManager();
  const [currentPage, setCurrentPage] = useState(0);
  const [currentData, setCurrentData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState(columns.map(col => col.accessor));
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const UserToken = keycloak.token;
  let username = '';
  let Email = '';

  if (UserToken !== undefined || UserToken !== null) {
    const decoded = jwt_decode(UserToken);
    username = decoded.preferred_username;
    Email = decoded.email;
  }

  useEffect(() => {
    const offset = currentPage * itemsPerPage;
    setCurrentData(data);
    setSelectedRows(selectedRows.filter(rowId => data.slice(offset, offset + itemsPerPage).some(row => row.id === rowId)));
  }, [currentPage, data, itemsPerPage]);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
    onPageChange(selected + 1);
  };

  const fileCountClicked = (buttonValue) => {
    const formdata = new FormData();
    formdata.append('selectedIndex', sessionStorage.getItem("SelectedFolderFile"));
    formdata.append("file_name", buttonValue);
    formdata.append("username", username);

    const token = localStorage.getItem('ApiToken');

    axios.post(`${API_BASE_URL}/api/file-upload-maker-download`, formdata, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      responseType: 'blob'
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const contentDisposition = response.headers['content-disposition'];
      let fileName = buttonValue;
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match?.length > 1) fileName = match[1];
      }
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      console.error("File download failed", error);
    });
  };

  const handleColumnChange = (newSelectedColumns) => {
    setSelectedColumns(newSelectedColumns);
    setIsModalOpen(false);
  };

  const handleRowSelect = (id) => {
    setSelectedRows(prev => prev.includes(id) ? prev.filter(r => r !== id) : [...prev, id]);
  };

  const handleSelectAll = () => {
    if (currentData.every(row => selectedRows.includes(row.id))) {
      setSelectedRows(selectedRows.filter(id => !currentData.some(row => row.id === id)));
    } else {
      setSelectedRows([...selectedRows, ...currentData.filter(row => !selectedRows.includes(row.id)).map(row => row.id)]);
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };

  return (
    <div>
      <div className="table-container">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <p className="total-records mb-0">Total Records: {totalRecords}</p>
        </div>
        <table className="table table-bordered">
          <thead className="table-light">
            <tr>
              <th>
                <input
                  type="checkbox"
                  checked={currentData.length > 0 && currentData.every(row => selectedRows.includes(row.id))}
                  onChange={handleSelectAll}
                />
              </th>
              {columns
                .filter(col => selectedColumns.includes(col.accessor))
                .map(col => (
                  <th key={col.accessor}>{col.header}</th>
              ))}
              <th>Download</th>
            </tr>
          </thead>
          <tbody>
            {dataLoading ? (
              <tr>
                <td colSpan={columns.length + 2} className="text-center py-4">
                  <div className="spinner-border text-primary mb-3" role="status"></div>
                  <div style={{ fontSize: "18px", fontWeight: "bold", color: "#0983b1" }}>Please wait..</div>
                </td>
              </tr>
            ) : (
              currentData.map((row) => (
                <tr key={row.id}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(row.id)}
                      onChange={() => handleRowSelect(row.id)}
                    />
                  </td>
                  {columns
                    .filter(col => selectedColumns.includes(col.accessor))
                    .map(col => (
                      <td key={col.accessor}>
                        {col.accessor === "id" ? row.id.toString().padStart(5, '0') :
                         col.accessor === "created_date" || col.accessor === "updated_date" ? (
                          <>
                            <i className="fa fa-calendar me-1 text-muted"></i>
                            {/* {row[col.accessor]} */}
                            {formatDateTime(row[col.accessor])}
                          </>
                        ) : col.accessor === "status" ? (
                          // <span className={`badge ${row.status === 'Approved' ? 'bg-success' : 'bg-warning text-dark'}`}>
                          <span
                            className={`badge ${
                              row.status === 'Approved'
                                ? 'bg-success'
                                : row.status === 'Rejected'
                                ? 'bg-danger'
                                : 'bg-warning text-dark'
                            }`}
                          >
                            {row.status}
                          </span>
                        ) : (
                          row[col.accessor]
                        )}
                      </td>
                    ))}
                  <td className="text-center">
                    <i
                      className="fa fa-download text-primary"
                      style={{ cursor: 'pointer', fontSize: '18px' }}
                      onClick={() => fileCountClicked(row.download_file_path)}
                      title="Download"
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <div className="table-controls d-flex justify-content-between align-items-center">
        {isCustomOpen && (
          <div>
            <button onClick={() => setIsModalOpen(true)} className="open-modal-button" style={{ width:"160px"}}>CUSTOMIZE TABLE</button>
            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
              <ColumnSelector
                columns={columns}
                selectedColumns={selectedColumns}
                onColumnChange={handleColumnChange}
              />
            </Modal>
          </div>
        )}
        <div className="pagination-container">
          <ReactPaginate
            previousLabel="Previous"
            nextLabel="Next"
            breakLabel="..."
            pageCount={Math.ceil(totalRecords / itemsPerPage)}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName="pagination"
            activeClassName="active"
          />
        </div>
      </div>

      {loading && (
        <div className="loading-overlay">
          <div className="spinner-border text-primary mb-3" role="status"></div>
          <div className="text-center mt-3" style={{ fontSize: "20px", fontWeight: "bold", color: "#0983b1" }}>
            <p>Please wait</p>
            <p>Files being Downloaded</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default DynamicPaginatedTable;


// ####################### New Code #############################

// import React, { useState, useEffect } from 'react';
// import jwt_decode from "jwt-decode";
// import axios from 'axios';
// import ReactPaginate from 'react-paginate';
// import './DynamicPaginatedTable.css';
// import config from '../../../config/config';
// import { usePopupManager } from '../../../providers/PopupManager/PopupManager';

// const { API_BASE_URL } = config;

// const DynamicPaginatedTable = ({ data, columns, itemsPerPage, onPageChange, isCustomOpen, totalRecords, handleCSVDownload, dataLoading }) => {
//   const { showPopup } = usePopupManager();
//   const [currentPage, setCurrentPage] = useState(0);
//   const [currentData, setCurrentData] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [progress, setProgress] = useState(0);

//   const UserToken = keycloak.token;
//   let username = '';
//   let Email = '';

//   if (UserToken !== undefined || UserToken !== null) {
//     const decoded = jwt_decode(UserToken);
//     username = decoded.preferred_username;
//     Email = decoded.email;
//   }

//   useEffect(() => {
//     const offset = currentPage * itemsPerPage;
//     setCurrentData(data);
//     setSelectedRows(selectedRows.filter(rowId => data.slice(offset, offset + itemsPerPage).some(row => row.id === rowId)));
//   }, [currentPage, data, itemsPerPage]);

//   const handlePageClick = ({ selected }) => {
//     setCurrentPage(selected);
//     onPageChange(selected + 1);
//   };

//   const fileCountClicked = (buttonValue) => {
//     const formdata = new FormData();
//     formdata.append('selectedIndex', sessionStorage.getItem("SelectedFolderFile"));
//     formdata.append("file_name", buttonValue);
//     formdata.append("username", username);

//     const token = localStorage.getItem('ApiToken');

//     axios.post(`${API_BASE_URL}/api/file-upload-maker-download`, formdata, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//       },
//       responseType: 'blob'
//     })
//     .then((response) => {
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement('a');
//       link.href = url;
//       const contentDisposition = response.headers['content-disposition'];
//       let fileName = buttonValue;
//       if (contentDisposition) {
//         const match = contentDisposition.match(/filename="?([^"]+)"?/);
//         if (match.length > 1) fileName = match[1];
//       }
//       link.setAttribute('download', fileName);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//     })
//     .catch((error) => {
//       console.error("File download failed", error);
//     });
//   };

//   const handleRowSelect = (id) => {
//     setSelectedRows(prev => prev.includes(id) ? prev.filter(r => r !== id) : [...prev, id]);
//   };

//   const handleSelectAll = () => {
//     if (currentData.every(row => selectedRows.includes(row.id))) {
//       setSelectedRows(selectedRows.filter(id => !currentData.some(row => row.id === id)));
//     } else {
//       setSelectedRows([...selectedRows, ...currentData.filter(row => !selectedRows.includes(row.id)).map(row => row.id)]);
//     }
//   };

//   return (
//     <div>
//       <div className="table-container">
//         <div className="d-flex justify-content-between align-items-center mb-2">
//           <p className="total-records mb-0">Total Records: {totalRecords}</p>
//         </div>
//         <table className="table table-bordered">
//           <thead className="table-light">
//             <tr>
//               <th>
//                 <input
//                   type="checkbox"
//                   checked={currentData.length > 0 && currentData.every(row => selectedRows.includes(row.id))}
//                   onChange={handleSelectAll}
//                 />
//               </th>
//               {columns.map(col => (
//                 <th key={col.accessor}>{col.Header}</th>
//               ))}
//               <th>Download</th>
//             </tr>
//           </thead>
//           <tbody>
//             {dataLoading ? (
//               <tr>
//                 <td colSpan={columns.length + 2} className="text-center py-4">
//                   <div className="spinner-border text-primary mb-3" role="status"></div>
//                   <div style={{ fontSize: "18px", fontWeight: "bold", color: "#0983b1" }}>Please wait..</div>
//                 </td>
//               </tr>
//             ) : (
//               currentData.map((row) => (
//                 <tr key={row.id}>
//                   <td>
//                     <input
//                       type="checkbox"
//                       checked={selectedRows.includes(row.id)}
//                       onChange={() => handleRowSelect(row.id)}
//                     />
//                   </td>
//                   {columns.map(col => (
//                     <td key={col.accessor}>
//                       {col.accessor === "id" ? row.id.toString().padStart(5, '0') :
//                        col.accessor === "created_date" || col.accessor === "updated_date" ? (
//                         <>
//                           <i className="fa fa-calendar me-1 text-muted"></i>{row[col.accessor]}
//                         </>
//                       ) : col.accessor === "status" ? (
//                         <span className={`badge ${row.status === 'Approved' ? 'bg-success' : 'bg-warning text-dark'}`}>
//                           {row.status}
//                         </span>
//                       ) : (
//                         row[col.accessor]
//                       )}
//                     </td>
//                   ))}
//                   <td className="text-center">
//                     <i
//                       className="fa fa-download text-primary"
//                       style={{ cursor: 'pointer', fontSize: '18px' }}
//                       onClick={() => fileCountClicked(row.download_file_path)}
//                       title="Download"
//                     />
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       <div className="table-controls d-flex justify-content-between align-items-center">
//         <div className="pagination-container">
//           <ReactPaginate
//             previousLabel="Previous"
//             nextLabel="Next"
//             breakLabel="..."
//             breakClassName="break-me"
//             pageCount={Math.ceil(totalRecords / itemsPerPage)}
//             marginPagesDisplayed={2}
//             pageRangeDisplayed={5}
//             onPageChange={handlePageClick}
//             containerClassName="pagination"
//             activeClassName="active"
//           />
//         </div>
//       </div>

//       {loading && (
//         <div className="loading-overlay">
//           <div className="spinner-border text-primary mb-3" role="status"></div>
//           <div className="text-center mt-3" style={{ fontSize: "20px", fontWeight: "bold", color: "#0983b1" }}>
//             <p>Please wait</p>
//             <p>Files being Downloaded</p>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default DynamicPaginatedTable;

